<div class="admin-container">
  <!-- Header Section -->
  <div class="admin-header">
    <h1 class="admin-title">
      <mat-icon class="admin-icon">business</mat-icon>
      Company Dashboard
    </h1>
    <p class="admin-subtitle">{{companyName || 'Manage your company stores and activities'}}</p>
  </div>

  <!-- Main Content Tabs -->
  <mat-tab-group class="admin-tabs" [(selectedIndex)]="selectedTabIndex">
    <!-- Dashboard Tab -->
    <mat-tab label="Dashboard">
      <div class="tab-content">
        <!-- Debug Info -->
        <div style="padding: 10px; background: #f0f0f0; margin-bottom: 10px;">
          <p>Company object: {{company ? 'EXISTS' : 'NULL'}}</p>
          <p>Company ID: {{company?.id || 'N/A'}}</p>
          <p>Company Name: {{company?.name || 'N/A'}}</p>
        </div>
        
        <!-- Company Information -->
        <mat-card class="company-info-card" *ngIf="company">
          <mat-card-header>
            <mat-card-title>
              <mat-icon>business</mat-icon>
              Company Information
            </mat-card-title>
            <div class="header-actions">
              <button mat-raised-button color="primary" (click)="openEditCompanyModal()">
                <mat-icon>edit</mat-icon>
                Edit
              </button>
            </div>
          </mat-card-header>
          <mat-card-content>
            <div class="company-info-grid">
              <div class="info-item">
                <label>Company Name</label>
                <p>{{company?.name || 'N/A'}}</p>
              </div>
              <div class="info-item">
                <label>Contact Name</label>
                <p>{{company?.contactName || 'N/A'}}</p>
              </div>
              <div class="info-item">
                <label>Contact Email</label>
                <p>{{company?.contactEmail || 'N/A'}}</p>
              </div>
              <div class="info-item">
                <label>Contact Phone</label>
                <p>{{company?.contactPhone || 'N/A'}}</p>
              </div>
              <div class="info-item">
                <label>Description</label>
                <p>{{company?.description || 'N/A'}}</p>
              </div>
              <div class="info-item">
                <label>Website</label>
                <p>{{company?.website || 'N/A'}}</p>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- Add Store Button -->
        <div class="add-store-button-container">
          <button mat-raised-button color="primary" (click)="showAddStoreForm = !showAddStoreForm">
            <mat-icon>{{showAddStoreForm ? 'close' : 'add'}}</mat-icon>
            {{showAddStoreForm ? 'Cancel' : 'Add New Store'}}
          </button>
        </div>

        <!-- Add Store Section -->
        <mat-card class="form-card" *ngIf="showAddStoreForm">
          <mat-card-header>
            <mat-card-title>
              <mat-icon>add_store</mat-icon>
              Add New Store
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <app-add-store [companyId]="companyId" (storeAdded)="onStoreAdded()"></app-add-store>
          </mat-card-content>
        </mat-card>

        <!-- Recent Stores -->
        <mat-card class="list-card">
          <mat-card-header>
            <mat-card-title>
              <mat-icon>history</mat-icon>
              Recent Stores
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="recent-stores-grid">
              @for (store of recentStores(); track store.id) {
                <mat-card class="store-card" (click)="viewStoreDetails(store)">
                  <mat-card-content>
                    <div class="store-card-header">
                      <h3>{{store.name || 'N/A'}}</h3>
                      <button mat-icon-button (click)="openEditStoreModal(store); $event.stopPropagation()">
                        <mat-icon>edit</mat-icon>
                      </button>
                    </div>
                    <p class="store-location">{{store.location || 'N/A'}}</p>
                    <p class="store-contact">{{store.email || 'N/A'}}</p>
                    <p class="store-contact">{{store.phone || 'N/A'}}</p>
                  </mat-card-content>
                </mat-card>
              }
              @if (recentStores().length === 0) {
                <div class="no-stores">
                  <mat-icon>store_mall_directory</mat-icon>
                  <p>No stores yet</p>
                </div>
              }
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>

    <!-- All Stores Tab -->
    <mat-tab label="All Stores">
      <div class="tab-content">
        <!-- Stores List -->
        <mat-card class="list-card">
          <mat-card-header>
            <mat-card-title>
              <mat-icon>store</mat-icon>
              All Company Stores
            </mat-card-title>
            <div class="header-actions">
              <mat-form-field appearance="outline" class="search-field">
                <mat-label>Search Stores</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Filter by name, location..." #input>
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>
          </mat-card-header>
          <mat-card-content>
            <div class="table-container">
              <table mat-table [dataSource]="dataSource" matSort class="admin-table">
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Store Name</th>
                  <td mat-cell *matCellDef="let row">
                    <div class="company-cell">
                      <strong>{{row.name || 'N/A'}}</strong>
                    </div>
                  </td>
                </ng-container>

                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                  <td mat-cell *matCellDef="let row">
                    <a [href]="'mailto:' + (row.email || '')" class="email-link">
                      {{row.email || 'N/A'}}
                    </a>
                  </td>
                </ng-container>

                <ng-container matColumnDef="phone">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
                  <td mat-cell *matCellDef="let row">{{row.phone || 'N/A'}}</td>
                </ng-container>

                <ng-container matColumnDef="location">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
                  <td mat-cell *matCellDef="let row">{{row.location || 'N/A'}}</td>
                </ng-container>

                <ng-container matColumnDef="siteLocation">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Site</th>
                  <td mat-cell *matCellDef="let row">{{row.siteLocation || 'N/A'}}</td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>Actions</th>
                  <td mat-cell *matCellDef="let row">
                    <button mat-icon-button [matMenuTriggerFor]="actionMenu" 
                            (click)="selectedStore = row">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #actionMenu="matMenu">
                      <button mat-menu-item (click)="openEditStoreModal(row)">
                        <mat-icon>edit</mat-icon>
                        Edit
                      </button>
                      <button mat-menu-item (click)="viewStoreDetails(row)">
                        <mat-icon>visibility</mat-icon>
                        View Details
                      </button>
                      <button mat-menu-item (click)="deleteStore(row)" class="delete-action">
                        <mat-icon>delete</mat-icon>
                        Delete
                      </button>
                    </mat-menu>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" 
                    class="table-row" (click)="viewStoreDetails(row)"></tr>

                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
                    <div class="no-data-content">
                      <mat-icon>store_mall_directory</mat-icon>
                      <p>No stores found</p>
                      <small *ngIf="input.value">No results for "{{input.value}}"</small>
                    </div>
                  </td>
                </tr>
              </table>
            </div>

            <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" 
                          [pageSize]="10" 
                          showFirstLastButtons
                          aria-label="Select page of stores">
            </mat-paginator>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<!-- Edit Store Modal -->
@if (showEditModal) {
  <div class="modal-overlay" (click)="closeEditModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>
          <mat-icon>edit</mat-icon>
          Edit Store
        </h2>
        <button mat-icon-button (click)="closeEditModal()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="modal-body">
        <!-- Edit store form will go here -->
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Store Name</mat-label>
          <input matInput [(ngModel)]="editingStore.name" placeholder="Store Name">
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Address / Location</mat-label>
          <input matInput [(ngModel)]="editingStore.location" placeholder="Street address, city">
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Site / Market</mat-label>
          <mat-select [(ngModel)]="editingStore.siteLocation" placeholder="Select site">
            <mat-option *ngFor="let opt of siteLocationOptions" [value]="opt.value">{{ opt.label }}</mat-option>
          </mat-select>
          <mat-hint>Which domain/market this store appears on</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input matInput type="email" [(ngModel)]="editingStore.email" placeholder="store@example.com">
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Phone</mat-label>
          <input matInput type="tel" [(ngModel)]="editingStore.phone" placeholder="+1 (555) 123-4567">
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Description</mat-label>
          <textarea matInput rows="4" [(ngModel)]="editingStore.description" placeholder="Store description..."></textarea>
        </mat-form-field>
      </div>
      <div class="modal-footer">
        <button mat-button (click)="closeEditModal()">Cancel</button>
        <button mat-raised-button color="primary" (click)="saveEditedStore()">
          <mat-icon>save</mat-icon>
          Save Changes
        </button>
      </div>
    </div>
  </div>
}

<!-- Edit Company Modal -->
<div *ngIf="showEditCompanyModal">
  <div class="modal-overlay" (click)="closeEditCompanyModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>
          <mat-icon>edit</mat-icon>
          Edit Company Information
        </h2>
        <button mat-icon-button (click)="closeEditCompanyModal()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="modal-body">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Company Name</mat-label>
          <input matInput [(ngModel)]="editingCompany.name" placeholder="Company Name">
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Contact Name</mat-label>
          <input matInput [(ngModel)]="editingCompany.contactName" placeholder="Contact Name">
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Contact Email</mat-label>
          <input matInput type="email" [(ngModel)]="editingCompany.contactEmail" placeholder="contact@company.com">
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Contact Phone</mat-label>
          <input matInput type="tel" [(ngModel)]="editingCompany.contactPhone" placeholder="+1 (555) 123-4567">
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Website</mat-label>
          <input matInput [(ngModel)]="editingCompany.website" placeholder="https://www.company.com">
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Description</mat-label>
          <textarea matInput rows="4" [(ngModel)]="editingCompany.description" placeholder="Company description..."></textarea>
        </mat-form-field>
      </div>
      <div class="modal-footer">
        <button mat-button (click)="closeEditCompanyModal()">Cancel</button>
        <button mat-raised-button color="primary" (click)="saveEditedCompany()">
          <mat-icon>save</mat-icon>
          Save Changes
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Loading Overlay -->
<div class="loading-overlay" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
  <p>Loading...</p>
</div>

<!-- Success/Error Messages -->
<!-- Messages are handled via MatSnackBar service in the component -->
